// The shape of one account lane, shared by the real map and the lanes it stands in for while the
// files are still coming, so nothing shifts when the accounts arrive.

export const MONTH_NAMES_HEIGHT = 'h-7'

// The name only has to stay put while its own months scroll past it. One year has nothing to
// scroll, so the name rides along like anything else. It sticks just under the month names.
export const LABEL_STAYS = 'sticky top-7 z-10'

// The first column is the year, a row heading for the months beside it.
export const GRID = '3.5rem repeat(12, minmax(1.75rem, 1fr))'

// Months sit apart enough to read as separate boxes. Stacked bars inside one year stay closer
// than two years do, so a year still reads as one row.
export const MONTH_GAP = 'gap-x-2 gap-y-1'

export const YEAR_GAP = 'space-y-3'

// A rule between accounts, none inside one, and none above the first (it would sit on the month
// names). Every other lane sits on a faint wash. Lanes off screen skip styling, or every menu that
// opens restyles the whole map. The last lane grows, so the column rule reaches the bottom.
export const LANE =
  'flex flex-col shrink-0 last:grow border-t first:border-t-0 px-4 [&:nth-of-type(even)]:bg-neutral-50 [content-visibility:auto] [contain-intrinsic-size:auto_400px]'

// The vertical padding sits on the two columns, not on the lane, so the line between the columns
// runs the lane's full height and meets the line above the next account.
export const LANE_PADDING = 'py-10'

export const LANE_ROW = 'flex last:grow'

// Member cards hang off their primary card as a tight, indented group, so the account's own row
// leaves less room under it. Their bars are thinner than a statement's: they file nothing.
export const MEMBERS_FOLLOW = 'pb-6'
export const MEMBER_ROW = 'group/member flex last:grow'
export const MEMBER_BAR_HEIGHT = '1.25rem'

// The account stands here, left of its months. Every lane reserves the same width, so the month
// columns start at the same place down the map.
export const LABEL_COLUMN = 'w-72 shrink-0 bg-inherit pr-8'

// The years and months, ruled off from the account on their left with room on both sides.
export const TIMELINE_COLUMN = 'min-w-0 flex-1 border-l pl-8'

// One bar or empty month is this tall; a row with stacked bars is a track per bar.
export const TRACK_HEIGHT = '2rem'

// The account column is a list of named facts, every value starting at the same place.
export const FACTS_GRID =
  'grid w-full min-w-0 grid-cols-[3.5rem_minmax(0,1fr)] items-baseline gap-x-3 gap-y-2'

// The counts are a different kind of fact from the account's name, so they sit further off it
// than any two of its rows sit apart.
export const FILING_GAP = 'mt-3'
